import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AvvidoParcellaForm } from 'src/app/common/form/parcelle/stragiudiziali/avviso-parcella-form';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { SezioneParcelleStragiudizialiResponse } from '../../../models/dto/sezione-parcelle-stragiudiziali-response';
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';
import { SezioneParcelleStragiudiziali } from '../../../models/sezioni/sezione-parcelle-stragiudiziali';

@Component({
    selector: 'div [avviso-parcella-form-add]',
  templateUrl: '../../../form/parcelle/stragiudiziali/avviso-parcella-form.html'
})

export class AvvisoParcellaAddComponent extends AvvidoParcellaForm {
  idSezione: string;
  urlInsert: string;
  urlReadSezioneLegali: string;
  urlReadSezioneEconomica: string;
  urlGetScaglioni: string;
  tipoFascicolo: any;
  tipoPratica: any;
  idFascicolo: string;

  @Output() onReturn: EventEmitter<SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleStragiudiziali>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Avviso di parcella');
    this.isInserimento(true);
  }

  getParcellaStragiudiziale() {
    return new ParcellaStragiudiziale();
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getTipoFascicolo(): any {
    return this.tipoFascicolo;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }

  getIdFascicolo() {
    return this.idFascicolo;
  }

  getUrlGetScaglioni() {
    return this.urlGetScaglioni;
  }

  getRequest(request: ParcellaStragiudiziale) {
    this.operationService.addParcellaStragiudiziale(this.urlInsert, request, this.idSezione , this.idFascicolo).subscribe((response: any) => this.datiParcellaStragiudiziale(response));
  }

  datiParcellaStragiudiziale(response: SezioneParcelleStragiudizialiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(idSezione: string,
              idFascicolo: string,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlInsert: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number) {
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.urlInsert = urlInsert;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlGetScaglioni = urlGetScaglioni;
    this.tipoFascicolo = tipoFascicolo;
    this.tipoPratica = tipoPratica;
    if (idSezioneLegali) {
      this.readSezioneLegali(idSezioneLegali);
    }
    if (idSezioneEconomica) {
      this.readSezioneEconomica(idSezioneEconomica);
    }
    this.createForm();
    this.populateSelect();
  }

}
